import React from 'react'
import {
  colWidthSelector,
  rawDragOffsetSelector
} from '../../store/selectors/boardSelectors'
import { connect } from 'react-redux'
import styled from 'react-emotion'

const GridContainer = connect(state => ({
  colWidth: colWidthSelector(state),
  show: !state.board.hideGrid || !!rawDragOffsetSelector(state)
}))

export const Grid = styled(
  ({ colWidth, show, first, className }) =>
    show && (
      <div className={className}>
        {Array(12)
          .fill()
          .map((v, i) => (
            <GridColumn i={i} first={first} colWidth={colWidth} key={i} />
          ))}
      </div>
    )
)({
  label: 'Grid',
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  pointerEvents: 'none'
})

const GridColumn = styled('div')(({ i, colWidth }) => ({
  label: 'GridColumn',
  // Example columns:
  //    1: 10px-29px
  //    2: 30px-49px
  //    3: 50px-69px
  // Borders are not on px values. Column 2 needs boarders between 29 and 30px (29.5)
  // and between 49 and 50px (49.5). We set left to 30px and width to 20px (col width
  // is 19 but we add 1) so the borders will be 30 and 50.
  // css transform:translateX(-0.5px) moves them to the right spot
  position: 'absolute',
  left: (i * 3 + 1) * colWidth,
  top: colWidth,
  bottom: colWidth,
  width: colWidth * 2 + 1,
  opacity: 0.3,
  border: '1px solid white',
  outline: '1px dashed #333',
  outlineOffset: -1,
  transform: 'translateX(-0.5px) translateZ(0)' // sit on the line between px: see note in Grid.js
}))

export default GridContainer(Grid)
